// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const BodyFileUploadApiFilesPost = zod.object({
  "file": zod.instanceof(Blob)
});

export type BodyFileUploadApiFilesPost = zod.input<typeof BodyFileUploadApiFilesPost>;
export type BodyFileUploadApiFilesPostOutput = zod.output<typeof BodyFileUploadApiFilesPost>;
